/**
 * This file is part of the Red Dress Boutique Shopify theme.
 */
if (!window.isUndefined) {
    window.isUndefined = function(value) {
        return typeof value === "undefined"
    }
}
if (!window.isDefined) {
    window.isDefined = function(value) {
        return typeof value !== "undefined"
    }
}
if (!window.isValue) {
    window.isValue = function(value) {
        return window.isDefined(value) && value && value !== ""
    }
}
(function(jQuery, Shopify) {
    Shopify.ShopTheLook = function(selector, config) {
        this.config = config;
        this.$link = jQuery(selector);
        this.init();
    };

    Shopify.ShopTheLook.prototype = {
        constructor: Shopify.ShopTheLook,
        init: function () {
            if (window.isValue(this.$link)) {
                this.$link.click((function() {
                    //this.openModal();
                }).bind(this));
            }
        },
        getAssociatedProductByHandle: function(productHandle) {
            if (!window.isValue(productHandle)) {
                return null;
            }
            for( var _counter = 0 ; _counter < this.config.associated.length ; _counter++ ) {
                var associatedProduct = this.config.associated[_counter];
                if (associatedProduct.handle === productHandle) {
                    return associatedProduct;
                }
            }

            return null;
        },
        gridItemFormHtml: function() {
          var templates = {
            'productForm': '<div class="product-form">' +
                '<form class="add_product_form" data-form-id="{{ ADD_PRODUCT_FORM_ID }}"' +
                  ' data-product-handle="{{productHandle}}"' +
                  ' action="/cart/add"' +
                  ' method="post"' +
                  ' enctype="multipart/form-data">' +
                    '{{productFormHtml}}' +
                    '<div class="product-add-success hide">Item Added!</div>' +
                '</form>' +
              '</div>',
            'productFormInner': '<div class="product-add-form">' +
              '</div>',
            'productFormSubmit': '<div class="buttons_row">' +
                '<div class="input-validation">error message</div>' +
                '<input data-action="SHOPLOOK_ADD_TO_CART_CLICK" class="add_product_submit" type="submit" name="" value="Add To Bag">' +
            '</div>'
          };

          var featuredProduct = this.config.featured;

          var productFormInnerHtml = jQuery(templates.productFormInner);
          var productFormSubmitHtml = jQuery(templates.productFormSubmit);
          var productFormOptionsHtml = jQuery('<div class="options_row"></div>');

          var productOptions = featuredProduct.options.sort(function(a,b) {
            return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
          });

          var productVariantSelectHtml = jQuery('<select name="id" class="no-js" style="display: none;"></select>');
          productVariantSelectHtml.append(jQuery('<option value=""></option>'));
          for( var _variant = 0 ; _variant < featuredProduct.variants.length ; _variant++ ) {
            var productVariant = featuredProduct.variants[_variant];
            var productVariantOptionHtml = jQuery("<option/>", {
                  value: productVariant.id,
                  text: productVariant.title,
                  selected: (featuredProduct.variants.length === 1)
                }
            );

            if (productVariant.available === false) {
              productVariantOptionHtml.attr('data-stock', 'no-stock');
            }

            productVariantSelectHtml.append(productVariantOptionHtml);
          }
          productFormOptionsHtml.append(productVariantSelectHtml);

          if (featuredProduct.variants.length !== 1) {
            for (var _option = 0; _option < productOptions.length; _option++) {
              var productOption = productOptions[_option];
              var productOptionSelectHtml = jQuery(
                  '<select name="' + productOption.name + '" data-option-position="' + productOption.position + '"></select>'
              );

              if (productOption.name !== 'Color') {
                productOptionSelectHtml.append(
                    jQuery('<option value="" disabled selected hidden>' + productOption.name.toUpperCase() + '</option>')
                );
              }

              jQuery.each(productOption.values, function (key, value) {
                productOptionSelectHtml.append(jQuery("<option/>", {
                  value: value,
                  text: value,
                  selected: (productOption.name === 'Color')
                }));
              });

              var productOptionWrapperHtml = jQuery('<div class="select-wrapper" data-option="' + productOption.name + '"></div>');
              productOptionWrapperHtml.append(productOptionSelectHtml);
              productFormOptionsHtml.append(productOptionWrapperHtml);
            }
          }

          productFormInnerHtml.append(productFormOptionsHtml);
          productFormInnerHtml.append(productFormSubmitHtml);

          var productFormHtml = templates.productForm
              .replace(/{{productFormHtml}}/g, productFormInnerHtml.html())
              .replace(/{{productHandle}}/g, featuredProduct.handle);

          return jQuery(productFormHtml);
        },
        modalHtml: function() {
            var itemHtml = jQuery('<div id="shop-the-look-modal" class="grid"></div>');
            var templates = {
                'productPriceHtml': '<div class="product-price">' +
                        '<span class="price">{{productPrice}}</span>' +
                    '</div>',
                'productSalePriceHtml': '<div class="product-price">' +
                    '<span class="price-compare">{{productOriginalPrice}}</span>' +
                        '<span class="price-sale">{{productSalePrice}}</span>' +
                    '</div>',
                'featuredProductHtml': '<div class="grid__item large--one-whole shoplook__featured-wrapper">' +
                        '<button title="Close (Esc)" type="button" class="mfp-close">x</button>' +
                        '<div class="shoplook__featured">' +
                            '<h1 class="product-name">{{productName}}</h1>' +
                            '<div class="product-price">{{productPriceHtml}}</div>' +
                            '<div class="bag-confirmation"><a class="pink button" href="/cart">GO TO MY BAG</a></div>' +
                        '</div>' +
                    '</div>',
                'featuredImageHtml': '<div class="grid__item large--one-half medium-down--three-quarters shoplook__featured-image">' +
                        '<a href="{{productUrl}}"><img src="{{imageUrl}}" alt="{{imageTitle}}" width="532" /></a>' +
                    '</div>',
                'associatedProductHtml': '<div class="shoplook__associated grid__item medium-down--one-half">' +
                        '<div class="shoplook__associated-head">' +
                            '<div class="shoplook__associated-image">' +
                                '<a href="{{productUrl}}"><img src="{{imageUrl}}" alt="{{imageTitle}}" width="163" /></a>' +
                            '</div>' +
                        '</div>' +
                        '<div class="shoplook__associated-content">' +
                            '<div class="shoplook__associated-pc-inner">' +
                                '<h5 class="product-name"><a href="{{productUrl}}">{{productName}}</a></h5>' +
                                '<div class="product-vendor hide">{{productVendor}}</div>' +
                                '<div class="product-price">{{productPriceHtml}}</div>' +
                                '<div class="product-form">' +
                                    '<form class="add_product_form" data-form-id="{{ ADD_PRODUCT_FORM_ID }}"' +
                                        ' data-product-handle="{{productHandle}}"' +
                                        ' action="/cart/add"' +
                                        ' method="post"' +
                                        ' enctype="multipart/form-data">' +
                                        '{{productFormHtml}}' +
                                        '<div class="product-add-success hide">Item Added!</div>' +
                                    '</form>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>',
                'associatedProductFormHtml': '<div class="product-add-form">' +
                    '</div>',
                'associatedProductFormSubmitHtml': '<div class="buttons_row">' +
                        '<div class="input-validation">error message</div>' +
                        '<input data-action="SHOPLOOK_ADD_TO_CART_CLICK" class="add_product_submit" type="submit" name="" value="Add To Bag">' +
                    '</div>'
            };

            var featuredProduct = this.config.featured;

            var featuredProductPriceHtml = templates.productPriceHtml
                .replace(/{{productPrice}}/g, featuredProduct.price);

            if (window.isValue(featuredProduct.originalPrice) && featuredProduct.price < featuredProduct.originalPrice) {
                featuredProductPriceHtml = templates.productSalePriceHtml
                    .replace(/{{productOriginalPrice}}/g, featuredProduct.originalPrice)
                    .replace(/{{productSalePrice}}/g, featuredProduct.price);
            }

            var featuredProductHtml = templates.featuredProductHtml
                .replace(/{{productName}}/g, featuredProduct.title)
                .replace(/{{productPriceHtml}}/g, featuredProductPriceHtml);

            itemHtml.append(featuredProductHtml);

            var featuredImageHtml = templates.featuredImageHtml
                .replace(/{{productUrl}}/g, '/products/' + featuredProduct.handle)
                .replace(/{{imageUrl}}/g, featuredProduct.image.url)
                .replace(/{{imageTitle}}/g, featuredProduct.image.title);
            itemHtml.append(featuredImageHtml);

            var associatedProductsHtml = jQuery('<div class="grid__item large--one-half medium-down--one-whole shoplook__associated-wrapper"></div>');
            for( var _counter = 0 ; _counter < this.config.associated.length ; _counter++ ){
                var associatedProduct = this.config.associated[_counter];

                var associatedProductPriceHtml = templates.productPriceHtml
                    .replace(/{{productPrice}}/g, associatedProduct.price);

                if (window.isValue(associatedProduct.originalPrice) && associatedProduct.price < associatedProduct.originalPrice) {
                    associatedProductPriceHtml = templates.productSalePriceHtml
                        .replace(/{{productOriginalPrice}}/g, associatedProduct.originalPrice)
                        .replace(/{{productSalePrice}}/g, associatedProduct.price);
                }

                var associatedProductFormHtml = jQuery(templates.associatedProductFormHtml);
                var associatedProductFormSubmitHtml = jQuery(templates.associatedProductFormSubmitHtml);

                var associatedProductOptions = associatedProduct.options.sort(function(a,b) {
                    return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0);
                });

                var associatedProductVariantSelectHtml = jQuery('<select name="id" class="no-js" style="display: none;"></select>');
                associatedProductVariantSelectHtml.append(jQuery('<option value=""></option>'));
                for( var _variant = 0 ; _variant < associatedProduct.variants.length ; _variant++ ) {
                    var associatedProductVariant = associatedProduct.variants[_variant];
                    var associatedProductVariantOptionHtml = jQuery("<option/>", {
                          value: associatedProductVariant.id,
                          text: associatedProductVariant.title,
                          selected: (associatedProduct.variants.length === 1)
                        }
                    );

                    if (associatedProductVariant.available === false) {
                        associatedProductVariantOptionHtml.attr('data-stock', 'no-stock');
                    }

                    associatedProductVariantSelectHtml.append(associatedProductVariantOptionHtml);
                }
                associatedProductFormHtml.append(associatedProductVariantSelectHtml);

                if (associatedProduct.variants.length !== 1) {
                  for (var _option = 0; _option < associatedProductOptions.length; _option++) {
                    var associatedProductOption = associatedProductOptions[_option];
                    var associatedProductOptionSelectHtml = jQuery(
                        '<select name="' + associatedProductOption.name + '" data-option-position="' + associatedProductOption.position + '"></select>'
                    );

                    associatedProductOptionSelectHtml.append(
                        jQuery('<option value="" disabled selected hidden>' + associatedProductOption.name.toUpperCase() + '</option>')
                    );
                    jQuery.each(associatedProductOption.values, function (key, value) {
                      associatedProductOptionSelectHtml.append(jQuery("<option/>", {
                        value: value,
                        text: value,
                        selected: (associatedProductOption.name === 'Color')
                      }));
                    });

                    var associatedProductOptionWrapperHtml = jQuery('<div class="select-wrapper" data-option="' + associatedProductOption.name + '"></div>');
                    associatedProductOptionWrapperHtml.append(associatedProductOptionSelectHtml);
                    associatedProductFormHtml.append(associatedProductOptionWrapperHtml);
                  }
                }

                associatedProductFormHtml.append(associatedProductFormSubmitHtml);

                var associatedProductHtml = templates.associatedProductHtml
                    .replace(/{{imageUrl}}/g, associatedProduct.image.url)
                    .replace(/{{imageTitle}}/g, associatedProduct.image.title)
                    .replace(/{{productName}}/g, associatedProduct.title)
                    .replace(/{{productUrl}}/g, '/products/' + associatedProduct.handle)
                    .replace(/{{productVendor}}/g, associatedProduct.vendor)
                    .replace(/{{productHandle}}/g, associatedProduct.handle)
                    .replace(/{{productPriceHtml}}/g, associatedProductPriceHtml)
                    .replace(/{{productFormHtml}}/g, associatedProductFormHtml.html());

                associatedProductsHtml.append(associatedProductHtml);
            }

            itemHtml.append(associatedProductsHtml);
            return itemHtml;
        },
        openModal: function() {
            var shoplook = this;
            var modalHtml = this.modalHtml();
            var items = [];
            items.push({
                src: modalHtml
            });

            $.magnificPopup.open({
                items: items,
                callbacks: {
                    open: (function () {
                        var instance = $.magnificPopup.instance;
                        var $container = jQuery(instance.contentContainer);
                        $container.on('click', '[data-action=SHOPLOOK_ADD_TO_CART_CLICK]', (function(event) {
                          event.preventDefault();
                          var $form = jQuery(event.target).closest('form');
                          this.addToCart($form);
                        }).bind(this));

                      window.setTimeout((function() {
                        var instance = $.magnificPopup.instance;
                        var $container = jQuery(instance.contentContainer);
                        this.watchVariants($container);

                        var imageH = jQuery('.shoplook__featured-image').height();
                        if (imageH) {
                          jQuery('.shoplook__associated-wrapper').css('max-height', imageH);
                        }
                      }).bind(this), 1000);
                    }).bind(shoplook),
                  resize: (function () {
                    var imageH = jQuery('.shoplook__featured-image').height();
                    if (imageH) {
                      jQuery('.shoplook__associated-wrapper').css('max-height', imageH);
                    }
                  })
                }
            });
        },
        addQuickOptions: function() {
          var shoplook = this;
          var productFormHtml = this.gridItemFormHtml();
          var $container = jQuery('.products_grid_item[data-handle="'+ this.config.featured.handle +'"]');
          var $info = $container.find('.info');

          $info.append(productFormHtml);
          shoplook.watchVariants($container);

          $container.on('click', '[data-action=SHOPLOOK_ADD_TO_CART_CLICK]', (function(event) {
            event.preventDefault();

            var $form = jQuery(event.target).closest('form');
            this.addToCart($form);
          }).bind(this));
        },
        watchVariants: function($container) {
          var shoplook = this;
          var variantSelect = $container.find('select[name=id]');
          var optionSelectors = $container.find('select').not(variantSelect);

          optionSelectors.on('change', function () {
            var $form = jQuery(this).closest('form');
            var selectedOptions = [];
            var selectors = $form.find('select');
            for (var _selector = 0; _selector < selectors.length; _selector++) {
              var $selector = jQuery(selectors[_selector]);
              var optionPosition = $selector.attr('data-option-position');
              if (window.isUndefined(optionPosition)) {
                continue;
              }
              selectedOptions[optionPosition - 1] = $selector.val();
            }
            selectedOptions = selectedOptions.filter(function (option) {
              return option;
            });

            var productHandle = $form.attr('data-product-handle');
            var associatedProduct = shoplook.getAssociatedProductByHandle(productHandle);
            if (selectedOptions.length !== associatedProduct.options.length) {
              return false;
            }

            $form.find('.buttons_row').removeClass('hide');
            $form.find('.product-add-success').addClass('hide');
            $form.find('.input-validation').removeClass('error');

            jQuery.each($form.find('.select-wrapper select'), function (index, elem) {
              var $elem = jQuery(elem);
              if (window.isValue($elem.val())) {
                $elem.removeClass('error');
              }
            });

            var matchingVariant;
            for (var i = 0; i < associatedProduct.variants.length; i++) {
              var variant = associatedProduct.variants[i];
              if (JSON.stringify(selectedOptions) === JSON.stringify(variant.options)) {
                matchingVariant = variant;
              }
            }

            if (!window.isValue(matchingVariant)) {
              return false;
            }

            // update price
            var variantPrice = matchingVariant.price || 0;
            $form.find('.product-price .price').html(Shopify.formatMoney(variantPrice, '${{amount_no_decimals}}'));

            var $submit = $form.find('input.add_product_submit');
            // verify variant is available
            var variantDisabled = !matchingVariant.available;
            if (variantDisabled) {
              $submit.prop('disabled', 1);
              $submit.addClass('no-stock');
              $submit.val('Out Of Stock');

              return false;
            }

            // step 3 - update form id in DOM
            $submit.prop('disabled', false);
            $submit.removeClass('no-stock');
            $submit.val('Add To Bag');
            $form.find('[name=id]').val(matchingVariant.id);
          });
        },
        addToCart: function($form) {
            
          var productVariantId = $form.find('[name=id]').val();
          var quantity = $form.find('[name=quantity]').val() || 1;
          var missingOptions = [];

          jQuery.each($form.find('.select-wrapper select'), function(index, elem) {
            
            var $elem = jQuery(elem);
            if (window.isValue($elem.val())) {
              $elem.removeClass('error');
            } else {
              $elem.addClass('error');
              missingOptions.push($elem.attr('name'));
            }
          });

          var $inputValidation = $form.find('.input-validation');
          if (missingOptions.length) {
            missingOptions.push('');
            $inputValidation.addClass('error');
            $inputValidation.text(missingOptions.join(' is required. '))
          } else {
            $inputValidation.removeClass('error');
          }

          if (!window.isValue(productVariantId)) {
            $form.find('input.add_product_submit').prop('disabled', 1);
            return false;
          }

          var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: 'quantity=' + quantity + '&id=' + productVariantId,
            dataType: 'json',
            success: function(line_item) {
              if(window.isValue(line_item)) {
                $form.find('.buttons_row').addClass('hide');
                $form.find('.product-add-success').removeClass('hide');
                jQuery.getJSON('/cart.js', function(cart) {
                  jQuery('.header__cart-count span.count').text(cart.item_count);
                  let cartData = cart.items;
                  document.documentElement.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true,
                      detail: cartData
                  }));
                });
              }
            },
            error: function(XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          };
          jQuery.ajax(params);
        }
    };
})(window.jQuery, window.Shopify);